module.exports = "<div class=\"legal\">\n\t<div class=\"container\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col col-sm-12 legal-info\">\n\t\t\t\t<h2>Adatvédelem</h2>\n\t\t\t\t<p>\n\t\t\t\t\t<a href=\"/assets/documents/aqua_apartman-adatvedelmi_szabalyzat.pdf\" target=\"_blank\" rel=\"nofollow\">Adatvédelmi szabályzat</a><br>\n\t\t\t\t\t<a href=\"/assets/documents/aqua_apartman-adatvedelmi_szabalyzat-melleklet.pdf\" target=\"_blank\" rel=\"nofollow\">Adatvédelmi szabályzat melléklet</a>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/legal/legal.component.html
// module id = ./src/app/legal/legal.component.html
// module chunks = 1